module.exports = __webpack_public_path__ + "static/media/collapse.792be9b4.svg";